import { useMemo } from 'react';
import { useTrackedPageContext } from 'src/context/trackedPage';
import {
  AnalyticsDataEvent,
  AnalyticsDataProperty,
  AnalyticsEventViewContent,
} from 'src/types/googleAnalyticsEvents';

export function useEventViewContent(): AnalyticsEventViewContent {
  const trackedPageContext = useTrackedPageContext();

  return useMemo(
    () => ({
      [AnalyticsDataProperty.event]: AnalyticsDataEvent.viewContent,
      ...trackedPageContext,
    }),
    [trackedPageContext],
  );
}
